function onTokenCreated(response) {
    window.angularComponentReference.zone.run(() => { window.angularComponentReference.onTokenCreated(response); });
}

function onTokenFailed(status, error) {
    console.log(status, error)
    window.angularComponentReference.zone.run(() => { window.angularComponentReference.onTokenFailed(); });
}